import React, {
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { Box, Grid2 } from "@mui/material";
import Left from "./components/left";
import withAuth from "../../hocs/withAuth";
import withApp from "../../hocs/withApp";
import {
  asyncGet,
  asyncGetList,
  asyncPostData,
  asyncPutData,
  asyncSearchList,
} from "../../utils/httpRequests";
import { useDispatch, useSelector } from "react-redux";
import { useAlertContext } from "../../contexts/alert/AlertProvider";
import {
  updateCurrentHd,
  updateTables,
} from "../../redux/reducers/restaurant.reducer";
import Right from "./components/right";
import { cloneDeep } from "lodash";
import { useBackdropContext } from "../../contexts/backdrop/BackdropProvider";
import { v4 } from "uuid";
import { DEFAULT_CUSTOMER } from "../../utils/ui.constants";
import PrintPBLNH from "../../components/common/print/pbl_nh/PrintPBLNH";
import { API_URL, ID_APP } from "../../utils/constants";
import axios from "axios";
import moment from "moment";

type RestaurantContextType = {
  showMenu: boolean;
  giamGia: { gia_tri: number; so_luong: number };
  pttts: any[];
  saveHd: (trang_thai: number) => any;
  setShowMenu: Dispatch<SetStateAction<boolean>>;
  selectTable: (ban?: any, notable?: boolean) => void;
  handleUpdateCurrentHd: (data: { [key: string]: any }) => void;
  updateCurrentTable: (ban: any) => void;
  handleAddProductToDetails: (args: {
    product: any;
    gia_ban_le: number;
    ma_dvt: string;
    ten_dvt: string;
    override?: boolean;
  }) => void;
};

const RestaurantContext = createContext<RestaurantContextType>({
  showMenu: false,
  giamGia: { gia_tri: 0, so_luong: 0 },
  pttts: [],
  setShowMenu: () => {},
  saveHd: () => {},
  selectTable: (ban?: any, notable?: boolean) => {},
  handleUpdateCurrentHd: () => {},
  handleAddProductToDetails: (args) => {},
  updateCurrentTable: () => {},
});
const apiCode = "pbl_nh";
const REQUIRE_CUSTOMER_STATUS = [3, 5];
const REQUIRE_TIENTHU_STATUS = [5];
const REQUIRE_PTTT_STATUS = [5];
const STATUS_SUCCESS = 5;
const STATUS_TEMP = 3;

function RestaurantPage() {
  const token = useSelector((state: any) => state.auth.token);
  const app = useSelector((state: any) => state.app.data);
  const currentStore = useSelector((state: any) => state.config.currentStore);
  const { tables, currentHd } = useSelector((state: any) => state.restaurant);
  const { showAlert } = useAlertContext();
  const { setOpenBackdrop } = useBackdropContext();
  const [showMenu, setShowMenu] = useState<boolean>(false);
  const [pttts, setPttts] = useState<any[]>([]);
  const dispatch = useDispatch();
  const contentPrintRef = useRef<any>();

  const handleCreateHd = async (ma_ban?: string): Promise<any> => {
    const hd = {
      ma_kho: currentStore?.ma_kho || "",
      ten_kho: currentStore?.ten_kho || "",
      ma_ban,
      pt_thanh_toan: "",
      ten_pt_thanh_toan: "",
      is_new: true,
      ma_kh: DEFAULT_CUSTOMER.ma_kh,
      ten_kh: DEFAULT_CUSTOMER.ten_kh,
      t_tien_nt: 0,
      t_ck_nt: 0,
      tien_ck_hd: 0,
      ty_le_ck_hd: 0,
      t_tt_nt: 0,
      tien_thu: 0,
      phai_tra: 0,
      trang_thai: 1,
      exfields: {},
      details: [],
      dien_giai: "",
    };
    const resp = await asyncPostData({
      apiCode,
      token,
      idApp: app?._id,
      data: hd,
    });
    if (!resp || resp?.status !== 200) {
      showAlert({
        type: "error",
        message: resp?.data?.error || resp?.data?.message || "Lỗi khi tạo đơn",
      });
      return undefined;
    } else {
      return resp.data;
    }
  };
  const updateCurrentTable = async (ban: any) => {
    if (!ban) return;
    // cập nhật lại trạng thái bàn
    const respTable = await asyncGet({
      apiCode: "dmban",
      token,
      idApp: app?._id,
      id: ban?._id,
    });
    if (respTable && respTable?.status === 200) {
      const table = respTable?.data;
      const cloneTables = cloneDeep(tables);
      const index = cloneTables.findIndex(
        (item: any) => item._id === table._id
      );
      cloneTables.splice(index, 1, table);
      dispatch(updateTables(cloneTables));
    }
  };
  const selectTable = async (ban?: any, notable: boolean = false) => {
    /**
     1. Bàn trống (là bàn KHÔNG tồn tại hóa đơn có mã bàn đó ở trạng thái = 1)
        - 
     2. Bàn đang có khách (là bàn CÓ tồn tại hóa đơn có mã bàn đó ở trạng thái = 1)
     */
    if (ban?.ma_ban === currentHd?.ma_ban && !notable) return;
    setOpenBackdrop?.(true);
    let hd;
    // Nếu không có bàn -> mua mang đi
    if (notable) {
      hd = await handleCreateHd();
    } else {
      // Tìm hóa đơn đã đang có khách đã lưu
      const respHD = await asyncGetList({
        apiCode,
        token,
        idApp: app._id,
        condition: {
          page: 1,
          limit: 1,
          q: {
            ma_kho: currentStore?.ma_kho,
            ma_ban: ban?.ma_ban,
            trang_thai: ban?.trang_thai_nh || 1,
          },
        },
      });
      if (!respHD || respHD?.status !== 200) {
        showAlert({
          type: "error",
          message:
            respHD?.data?.error ||
            respHD?.data?.message ||
            "Lỗi khi tải thông tin đơn hàng",
        });
      } else {
        hd = (respHD?.data || [])[0];
        // Nếu không có hóa đơn đã lưu -> bàn đang trống -> tạo mới đơn
        if (!hd) {
          hd = await handleCreateHd(ban.ma_ban);
          // cập nhật lại trạng thái bàn
          await updateCurrentTable(ban);
        }
      }
    }
    dispatch(updateCurrentHd(hd));
    setOpenBackdrop?.(false);
  };
  const handleUpdateCurrentHd = (updateData: { [key: string]: any } = {}) => {
    const hdData = { ...currentHd, ...updateData };
    dispatch(updateCurrentHd(hdData));
  };
  type handleAddProductToDetailsType = {
    product: any;
    gia_ban_le: number;
    ma_dvt: string;
    ten_dvt: string;
    override?: boolean;
  };
  const handleAddProductToDetails = ({
    product,
    gia_ban_le,
    ma_dvt,
    ten_dvt,
    override = false,
  }: handleAddProductToDetailsType) => {
    if (!currentHd) {
      showAlert({ type: "warning", message: "Vui lòng chọn phiếu ăn trước" });
      return;
    }
    const { ma_vt, ten_vt, gia_mua, ma_nvt, ten_nvt } = product;
    const detailData = {
      _id: v4(),
      dien_giai: "",
      ma_vt,
      ten_vt,
      ma_nvt,
      ten_nvt,
      ma_dvt,
      ten_dvt,
      gia_ban: gia_ban_le,
      gia_ban_nt: gia_ban_le,
      gia_ban_le_goc: gia_ban_le,
      gia_von: gia_mua,
      gia_von_nt: gia_mua,
      sl_order: 1,
      sl_xuat: 1,
      tien_hang: gia_ban_le,
      tien_hang_nt: gia_ban_le,
      tien_ck: 0,
      tien_ck_nt: 0,
      ty_le_ck: 0,
      tien: gia_ban_le,
      tien_nt: gia_ban_le,
      tien_xuat: gia_ban_le,
      tien_xuat_nt: gia_ban_le,
      tk_dt: "51111",
      tk_gv: "6321",
      tk_vt: "1561",
    };
    const currentHdClone = cloneDeep(currentHd);

    if (!!override) {
      const existedDetail = (currentHdClone?.details || []).find(
        (item: any) => item.ma_vt === product.ma_vt
      );
      if (!!existedDetail) {
        existedDetail.sl_order += 1;
        existedDetail.sl_xuat = existedDetail.sl_order;
        const tienCk: number =
          Math.floor(
            ((existedDetail.ty_le_ck || 0) *
              (existedDetail.gia_ban_le_goc || 0)) /
              100
          ) * existedDetail.sl_order;
        existedDetail.tien_ck_nt = tienCk;
      } else {
        currentHdClone.details.push(detailData);
      }
    } else {
      currentHdClone.details.push(detailData);
    }
    handleUpdateCurrentHd({ details: currentHdClone.details });
  };
  const handlePrint = async (idHd: string) => {
    try {
      const printInfos = (currentStore?.printers || []).filter(
        (item: any) => item.ma_cn.toLowerCase() === apiCode
      );
      if (!printInfos || printInfos?.length < 1) {
        showAlert({
          type: "warning",
          message: `Chi nhánh hiện tại cài đặt máy in`,
        });
        return;
      }
      for (let i = 0; i < printInfos?.length; i++) {
        const printInfo = printInfos[i];
        const idMauIn = printInfo.id_mau_in;
        const printUrl = `${API_URL}/${ID_APP}/${apiCode}/excel/${idMauIn}?_id=${idHd}&print=1&access_token=${token}`;
        const resp = await axios.get(printUrl);
        let content: any;
        if (resp && resp.status === 200) {
          content = resp.data;
          await axios.post(
            `http://localhost:8081/html-print?printer=${printInfo?.ten_may_in}`,
            { html_content: content }
          );
        }
      }
    } catch (error: any) {
      showAlert({
        type: "error",
        message:
          error?.response?.data?.error ||
          error?.response?.data?.message ||
          error?.error ||
          "Lỗi khi in hóa đơn",
      });
    }
  };

  const saveHd = async (trang_thai: number = 0) => {
    const { _id, is_new, details, ...fields } = currentHd;
    const method = !is_new ? asyncPutData : asyncPostData;
    const hdToSave = {
      ...fields,
      ngay_ct: moment().toISOString(),
      trang_thai,
      details: details.map((detail: any) => {
        const { _id, ...detailData } = detail;
        return {
          ...detailData,
        };
      }),
    };
    if (REQUIRE_CUSTOMER_STATUS.includes(trang_thai) && !hdToSave.ma_kh) {
      showAlert({
        type: "warning",
        message: "Vui lòng chọn khách hàng",
      });
      return;
    }
    if (
      REQUIRE_TIENTHU_STATUS.includes(trang_thai) &&
      hdToSave.tien_thu < hdToSave.t_tt_nt
    ) {
      showAlert({ type: "warning", message: "Số tiền thu chưa đủ" });
      return;
    }
    if (REQUIRE_PTTT_STATUS.includes(trang_thai) && !hdToSave.pt_thanh_toan) {
      showAlert({
        type: "warning",
        message: "Vui lòng chọn phương thức thanh toán",
      });
      return;
    }
    setOpenBackdrop?.(true);
    const resp = await method({
      apiCode,
      data: hdToSave,
      id: _id,
      token,
      idApp: app?._id,
    });
    if (resp?.status !== 200) {
      showAlert({
        type: "error",
        message:
          resp?.data?.error || resp?.data?.messsage || "Lỗi khi lưu hóa đơn",
      });
      setOpenBackdrop?.(false);
      return;
    } else {
      if (STATUS_SUCCESS === trang_thai) {
        dispatch(updateCurrentHd(null));
        showAlert({ type: "success", message: "Thanh toán hoàn tất" });
        // handlePrint(resp?.data?._id, trang_thai);
        handlePrint(resp?.data?._id);
      }
      if (STATUS_TEMP === trang_thai) {
        // handlePrint(resp?.data?._id, trang_thai);
      }
      // cập nhật trạng thái bàn
      const currentTable = (tables || []).find(
        (item: any) => item.ma_ban === currentHd?.ma_ban
      );
      await updateCurrentTable(currentTable);
      setOpenBackdrop?.(false);
      return resp?.data;
    }
  };

  const getPttts = async () => {
    setOpenBackdrop?.(true);
    const resp = await asyncSearchList({
      apiCode: "ptthanhtoan",
      token,
      idApp: app?._id,
      condition: { page: 1, limit: 999999 },
    });
    if (resp?.status !== 200) {
      showAlert({
        type: "error",
        message:
          resp?.data?.error ||
          resp?.data?.message ||
          "Lỗi khi tải phương thức thanh toán",
      });
      setOpenBackdrop?.(false);
      return;
    }
    setPttts(resp?.data || []);
    setOpenBackdrop?.(false);
  };
  const initData = () => {
    getPttts();
  };

  const giamGia: { gia_tri: number; so_luong: number } = useMemo(() => {
    if (!currentHd) return { gia_tri: 0, so_luong: 0 };
    let giaTri = 0;
    let soLuong = 0;
    let item;
    for (let i = 0; i < currentHd.details.length; i++) {
      item = currentHd.details[i];

      if (item.tien_ck_nt > 0) {
        giaTri += item.tien_ck_nt;
        soLuong += 1;
      }
    }
    return {
      gia_tri: giaTri,
      so_luong: soLuong,
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentHd]);

  useEffect(() => {
    initData();
    return () => {
      dispatch(updateCurrentHd(null));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div hidden>
        <PrintPBLNH hd={currentHd} ref={contentPrintRef} />
      </div>
      <RestaurantContext.Provider
        value={{
          showMenu,
          giamGia,
          pttts,
          saveHd,
          setShowMenu,
          selectTable,
          updateCurrentTable,
          handleUpdateCurrentHd,
          handleAddProductToDetails,
        }}
      >
        <Box>
          <Grid2 container>
            <Grid2 size={{ xs: 12, md: 6 }}>
              <Left />
            </Grid2>
            <Grid2 size={{ xs: 12, md: 6 }}>
              <Right />
            </Grid2>
          </Grid2>
        </Box>
      </RestaurantContext.Provider>
    </>
  );
}

export default withAuth(withApp(RestaurantPage));

export const useRestaurantContext = () => {
  const value = useContext(RestaurantContext);
  if (!value) {
    throw new Error("RestaurantContext must be used inside PosProvider");
  }
  return value;
};
